module.exports = __webpack_public_path__ + "img/alan.04f02ba0.jpg";